import React from "react";
import { PageHeader } from "@/components/shell/TopBar";
import { AtlasAssistantPanel } from "@/components/atlas/AtlasAssistantPanel";
import { useI18n } from "@/i18n";

export default function Atlas() {
  const { d, lang } = useI18n();
  return (
    <div data-testid="atlas-page">
      <PageHeader title={d.atlas.title}
        subtitle={lang === "tr" ? "Maçları ve ATLAS analizlerini konuşarak incele." : "Explore matches and ATLAS analysis by conversation."} />
      <AtlasAssistantPanel />
    </div>
  );
}
